import { createFileRoute, redirect } from "@tanstack/react-router";

/** Старый вложенный адрес статьи. Постоянный редирект на плоский URL. */
export const Route = createFileRoute("/blog/marketing_/cost-accounting")({
  beforeLoad: () => {
    throw redirect({ to: "/blog/$slug", params: { slug: "cost-accounting" }, statusCode: 301 });
  },
});
